import { SelectInput } from "../../../shared/dropdown/shared/select-input.class";

export interface DataEndChannelTypeDefaults {
    fg?: number;
    de?: number;
    localbusAddress?: number;
    eakanalnr?: number;
}

export enum DataEndChannelTypeEnum {
    Unknown,
    LED,
    PW,
    BLINKER,
    RADAR,
    CLUSTER,
    FUELCELL,
    DIGITALINPUT,
    DIGITALOUTPUT,
    RADARPOWERSWITCH,
    LEDPOWERSWITCH,
    ROUTER,
    SOLAR,
    EVAVOLTAGE,
    BLINKER_CLUSTER,
    PW_CLUSTER,
    BRIGHTNESS100,
    ONLINE_LED,
    LPCam = 18,
    DOM_CAMERA = 19,
    LANESWITCH,
    BAR,
    SWING,
    WEATHER,
    CERBO_SOLAR
}

export function getDataEndChannelTypeIcon(type: DataEndChannelTypeEnum): string {
    switch (type) {
        case DataEndChannelTypeEnum.Unknown:
            return 'assets/icons/data-end-channel/unknown settings.svg';
        case DataEndChannelTypeEnum.LED:
            return 'assets/icons/data-end-channel/led.svg';
        case DataEndChannelTypeEnum.PW:
            return 'assets/icons/data-end-channel/pw.svg';
        case DataEndChannelTypeEnum.BLINKER:
            return 'assets/icons/data-end-channel/blinker.svg';
        case DataEndChannelTypeEnum.RADAR:
            return 'assets/icons/data-end-channel/radar_aq.svg';
        case DataEndChannelTypeEnum.CLUSTER:
            return 'assets/icons/data-end-channel/cluster.svg';
        case DataEndChannelTypeEnum.FUELCELL:
            return 'assets/icons/data-end-channel/fuelcell.svg';
        case DataEndChannelTypeEnum.DIGITALINPUT:
            return 'assets/icons/data-end-channel/digitalinput.svg';
        case DataEndChannelTypeEnum.DIGITALOUTPUT:
            return 'assets/icons/data-end-channel/digitaloutput.svg';
        case DataEndChannelTypeEnum.RADARPOWERSWITCH:
            return 'assets/icons/data-end-channel/radarpowerswitch.svg';
        case DataEndChannelTypeEnum.LEDPOWERSWITCH:
            return 'assets/icons/data-end-channel/ledpowerswitch.svg';
        case DataEndChannelTypeEnum.ROUTER:
            return 'assets/icons/data-end-channel/router.svg';
        case DataEndChannelTypeEnum.SOLAR:
            return 'assets/icons/data-end-channel/solar.svg';
        case DataEndChannelTypeEnum.EVAVOLTAGE:
            return 'assets/icons/data-end-channel/evavoltage.svg';
        case DataEndChannelTypeEnum.BLINKER_CLUSTER:
            return 'assets/icons/data-end-channel/blinkercluster.svg';
        case DataEndChannelTypeEnum.PW_CLUSTER:
            return 'assets/icons/data-end-channel/pw_cluster.svg';
        case DataEndChannelTypeEnum.BRIGHTNESS100:
            return 'assets/icons/data-end-channel/brightness100.svg';
        case DataEndChannelTypeEnum.ONLINE_LED:
            return 'assets/icons/data-end-channel/online_led.svg';
        case DataEndChannelTypeEnum.LPCam:
            return 'assets/icons/data-end-channel/lpcam.svg';
        case DataEndChannelTypeEnum.DOM_CAMERA:
            return 'assets/icons/data-end-channel/ptzcam.svg';
        case DataEndChannelTypeEnum.LANESWITCH:
            return 'assets/icons/data-end-channel/laneswitch.svg';
        case DataEndChannelTypeEnum.BAR:
            return 'assets/icons/data-end-channel/bar.svg';
        case DataEndChannelTypeEnum.SWING:
            return 'assets/icons/data-end-channel/swing.svg';
        case DataEndChannelTypeEnum.WEATHER:
            return 'assets/icons/data-end-channel/weather.svg';
        case DataEndChannelTypeEnum.CERBO_SOLAR:
            return 'assets/icons/data-end-channel/solar.svg';
        default:
            return 'assets/icons/data-end-channel/';
    }
}

export function getDataEndChannelTypeString(type: DataEndChannelTypeEnum): string {
    switch (type) {
        case DataEndChannelTypeEnum.Unknown:
            return 'Sonstiges';
        case DataEndChannelTypeEnum.LED:
            return 'LED-Anzeige';
        case DataEndChannelTypeEnum.PW:
            return 'Prismenwender';
        case DataEndChannelTypeEnum.BLINKER:
            return 'Blinker';
        case DataEndChannelTypeEnum.RADAR:
            return 'Radar';
        case DataEndChannelTypeEnum.CLUSTER:
            return 'Cluster';
        case DataEndChannelTypeEnum.FUELCELL:
            return 'Brennstoffzelle';
        case DataEndChannelTypeEnum.DIGITALINPUT:
            return 'Digitaler Eingang';
        case DataEndChannelTypeEnum.DIGITALOUTPUT:
            return 'Digitaler Ausgang';
        case DataEndChannelTypeEnum.RADARPOWERSWITCH:
            return 'Radar-Powerswitch';
        case DataEndChannelTypeEnum.LEDPOWERSWITCH:
            return 'LED-Powerswitch';
        case DataEndChannelTypeEnum.ROUTER:
            return 'Router';
        case DataEndChannelTypeEnum.SOLAR:
            return 'Solar';
        case DataEndChannelTypeEnum.EVAVOLTAGE:
            return 'EVA Spannung';
        case DataEndChannelTypeEnum.BLINKER_CLUSTER:
            return 'Blinker Cluster';
        case DataEndChannelTypeEnum.PW_CLUSTER:
            return 'PW Cluster';
        case DataEndChannelTypeEnum.BRIGHTNESS100:
            return 'Helligkeitskanal';
        case DataEndChannelTypeEnum.ONLINE_LED:
            return 'Online LED';
        case DataEndChannelTypeEnum.LPCam:
            return 'Höhen Kamera';
        case DataEndChannelTypeEnum.DOM_CAMERA:
            return 'Dom Kamera';
        case DataEndChannelTypeEnum.LANESWITCH:
            return 'Weiche';
        case DataEndChannelTypeEnum.BAR:
            return 'Schranke';
        case DataEndChannelTypeEnum.SWING:
            return 'Drehschild';
        case DataEndChannelTypeEnum.WEATHER:
            return 'Wetter';
        case DataEndChannelTypeEnum.CERBO_SOLAR:
            return 'Cerbo Solar';
        default:
            return 'Unbekannt';
    }
}

export function getDataEndChannelTypeSelect(): SelectInput[] {
    return [
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.LED), id: DataEndChannelTypeEnum.LED },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.PW), id: DataEndChannelTypeEnum.PW },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.RADAR), id: DataEndChannelTypeEnum.RADAR },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.BLINKER), id: DataEndChannelTypeEnum.BLINKER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.CLUSTER), id: DataEndChannelTypeEnum.CLUSTER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.Unknown), id: DataEndChannelTypeEnum.Unknown },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.FUELCELL), id: DataEndChannelTypeEnum.FUELCELL },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.DIGITALINPUT), id: DataEndChannelTypeEnum.DIGITALINPUT },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.DIGITALOUTPUT), id: DataEndChannelTypeEnum.DIGITALOUTPUT },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.RADARPOWERSWITCH), id: DataEndChannelTypeEnum.RADARPOWERSWITCH },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.LEDPOWERSWITCH), id: DataEndChannelTypeEnum.LEDPOWERSWITCH },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.ROUTER), id: DataEndChannelTypeEnum.ROUTER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.SOLAR), id: DataEndChannelTypeEnum.SOLAR },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.EVAVOLTAGE), id: DataEndChannelTypeEnum.EVAVOLTAGE },

        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.BLINKER_CLUSTER), id: DataEndChannelTypeEnum.BLINKER_CLUSTER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.PW_CLUSTER), id: DataEndChannelTypeEnum.PW_CLUSTER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.LANESWITCH), id: DataEndChannelTypeEnum.LANESWITCH },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.BAR), id: DataEndChannelTypeEnum.BAR },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.SWING), id: DataEndChannelTypeEnum.SWING },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.BRIGHTNESS100), id: DataEndChannelTypeEnum.BRIGHTNESS100 },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.DOM_CAMERA), id: DataEndChannelTypeEnum.DOM_CAMERA },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.LPCam), id: DataEndChannelTypeEnum.LPCam },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.ONLINE_LED), id: DataEndChannelTypeEnum.ONLINE_LED },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.WEATHER), id: DataEndChannelTypeEnum.WEATHER },
        { name: getDataEndChannelTypeString(DataEndChannelTypeEnum.CERBO_SOLAR), id: DataEndChannelTypeEnum.CERBO_SOLAR }
    ];
}

export function getDataEndChannelTypeDefaults(type: DataEndChannelTypeEnum): DataEndChannelTypeDefaults {
    switch (type) {
        case DataEndChannelTypeEnum.Unknown:
            return { fg: 6 };
        case DataEndChannelTypeEnum.LED:
            return { fg: 4, localbusAddress: 1, eakanalnr: 1, de: 1 };
        case DataEndChannelTypeEnum.PW:
            return { fg: 4, localbusAddress: 8, eakanalnr: 1, de: 1 };
        case DataEndChannelTypeEnum.BLINKER:
            return { fg: 4, localbusAddress: 6, eakanalnr: 1, de: 2 };
        case DataEndChannelTypeEnum.CLUSTER:
            return { fg: 4, localbusAddress: 0, eakanalnr: 0, de: 0 };
        case DataEndChannelTypeEnum.RADAR:
            return { fg: 1, localbusAddress: 8, eakanalnr: 1, de: 0};
        case DataEndChannelTypeEnum.FUELCELL:
            return { fg: 6, localbusAddress: 12, eakanalnr: 1, de: 34 };
        case DataEndChannelTypeEnum.DIGITALINPUT:
            return { fg: 6, localbusAddress: 6, eakanalnr: 1, de: 0};
        case DataEndChannelTypeEnum.DIGITALOUTPUT:
            return { fg: 6, localbusAddress: 6, eakanalnr: 7, de: 7 };
        case DataEndChannelTypeEnum.RADARPOWERSWITCH:
            return { fg: 6, localbusAddress: 6, eakanalnr: 8, de: 8 };
        case DataEndChannelTypeEnum.LEDPOWERSWITCH:
            return { fg: 6, localbusAddress: 6, eakanalnr: 9, de: 9 };
        case DataEndChannelTypeEnum.ROUTER:
            return { fg: 6, localbusAddress: 7, eakanalnr: 1, de: 10 };
        case DataEndChannelTypeEnum.SOLAR:
            return { fg: 6, localbusAddress: 10, eakanalnr: 1, de: 1 };
        case DataEndChannelTypeEnum.EVAVOLTAGE:
            return { fg: 6, localbusAddress: 6, eakanalnr: 5, de: 5 };
        case DataEndChannelTypeEnum.BLINKER_CLUSTER:
            return { fg: 4, localbusAddress: 6, eakanalnr: 0, de: 195 };
        case DataEndChannelTypeEnum.PW_CLUSTER:
            return { fg: 4, localbusAddress: 8, eakanalnr: 0, de: 194 };
        case DataEndChannelTypeEnum.BRIGHTNESS100:
            return { fg: 3, localbusAddress: 1, eakanalnr: 1, de: 1 };
        case DataEndChannelTypeEnum.ONLINE_LED:
            return { fg: 6, localbusAddress: 6, eakanalnr: 6, de: 6 };
        case DataEndChannelTypeEnum.LPCam:
            return { fg: 6, localbusAddress: 14, eakanalnr: 1, de: 0 };
        case DataEndChannelTypeEnum.DOM_CAMERA:
            return { fg: 6, localbusAddress: 15, eakanalnr: 1, de: 0 };
        case DataEndChannelTypeEnum.LANESWITCH:
            return { fg: 7, localbusAddress: 5, eakanalnr: 1, de: 0 };
        case DataEndChannelTypeEnum.BAR:
            return { fg: 7, localbusAddress: 5, eakanalnr: 2, de: 0};
        case DataEndChannelTypeEnum.SWING:
            return { fg: 7, localbusAddress: 5, eakanalnr: 3, de: 0 };
        case DataEndChannelTypeEnum.WEATHER:
            return { fg: 6, localbusAddress: 13, eakanalnr: 1, de: 0 };
        case DataEndChannelTypeEnum.CERBO_SOLAR:
            return { fg: 6, localbusAddress: 16, eakanalnr: 1, de: 0 };
        default:
            return {};
    }
}
